import React, { useEffect } from "react";
import LandingNav from "../../components/LandingNav";

const goToLogin = () => { window.location.href = "/login"; };

const ASSET_BASE = `${process.env.REACT_APP_UPLOADED_URL}/realestate/landing`;

const LandingPage: React.FC = () => {
  useEffect(() => {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = "https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&family=Poppins:wght@400;500;600&display=swap";
    document.head.appendChild(link);

    const prev = document.body.style.overflow;
    document.body.style.overflow = "auto";
    return () => { document.body.style.overflow = prev; };
  }, []);

  return (
    <div style={{ fontFamily: "'Poppins', sans-serif" }} className="text-[#2b2c2d]">

      <LandingNav active="home" />

      {/* 1. HERO VIDEO */}
      <section className="relative w-full h-screen overflow-hidden">
        <video
          className="absolute inset-0 w-full h-full object-cover"
          src={`${ASSET_BASE}/landing-hero.mp4`}
          autoPlay
          muted
          loop
          playsInline
        />
        <div className="absolute inset-0 bg-black/40" />
        <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-6">
          <h1 style={{ fontFamily: "'DM Sans', sans-serif" }} className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
            Scale with opensky
          </h1>
          <p className="text-lg md:text-xl text-white/80 max-w-2xl mb-10">
            The Platform to more than double your Real Estate Agency transactions and Revenue.
          </p>
          <button
            onClick={goToLogin}
            className="px-8 py-3 rounded-[6px] bg-white text-black font-semibold text-sm hover:bg-white/90 transition-colors"
          >
            Get Started
          </button>
        </div>
      </section>

      {/* 2. GROW YOUR PROJECT SALES - 3 COLS ON BLACK */}
      <section className="bg-black py-16 px-6">
        <div className="max-w-[1200px] mx-auto">
          <h2 style={{ fontFamily: "'DM Sans', sans-serif" }} className="text-3xl md:text-4xl font-bold text-white mb-12 text-center">
            Grow your Project Sales Multifold
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {[
              {
                img: `${ASSET_BASE}/feature-card-3.png`,
                title: "2x Your Current Revenue with Our Solutions",
                text: "Bring properties to life in a way that photos alone never could, from the overall flow down to the smallest detail With Our VR Technology and give flexibility to buyers to view from the comfort of their own space.",
              },
              {
                img: `${ASSET_BASE}/feature-card-1.png`,
                title: "Attract up to 4x Qualified Buyers.",
                text: "Allow customers to virtually tour the proposed property with flexibility to see multiple times with views that will highlight the Real Estate Property you are showcasing.",
              },
              {
                img: `${ASSET_BASE}/feature-card-2.png`,
                title: "Save Time And Budget with upto 10x ROI for your platform spends",
                text: "Shift to our Platform with Digital Twins presented through our customized VR devices of OpenSky, Having 24x7 access to your RE sites day or night virtually for your agents and clients.",
              },
            ].map((col) => (
              <div key={col.title} className="flex flex-col">
                <img src={col.img} alt={col.title} className="w-full object-cover rounded-[8px] mb-4" />
                <h3 style={{ fontFamily: "'DM Sans', sans-serif" }} className="text-white font-semibold text-lg mb-3">{col.title}</h3>
                <p className="text-white/70 text-sm leading-relaxed">{col.text}</p>
              </div>
            ))}
          </div>
          <div className="text-center mt-10">
            <button
              onClick={goToLogin}
              className="px-8 py-3 rounded-[6px] border border-white text-white text-sm font-semibold hover:bg-white hover:text-black transition-colors"
            >
              OUR BENEFITS.
            </button>
          </div>
        </div>
      </section>

      {/* 3. PROPERTY LISTING BANNER */}
      <section
        className="relative py-24 px-6 flex items-center justify-start"
        style={{
          backgroundImage: `url(${ASSET_BASE}/hero-bg.png)`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundAttachment: "fixed",
        }}
      >
        <div className="absolute inset-0 bg-black/50" />
        <div className="relative z-10 max-w-[1200px] mx-auto w-full">
          <h2 style={{ fontFamily: "'DM Sans', sans-serif" }} className="text-4xl md:text-5xl font-bold text-white mb-8">
            Property listing
          </h2>
          <div className="flex flex-wrap gap-4">
            <button
              onClick={goToLogin}
              className="px-6 py-3 rounded-[6px] bg-[#b7aca2] text-[#262626] text-sm font-semibold hover:bg-[#a89d93] transition-colors"
            >
              List Your Agency Properties
            </button>
            <button
              onClick={goToLogin}
              className="px-6 py-3 rounded-[6px] bg-[#b7aca2] text-[#262626] text-sm font-semibold hover:bg-[#a89d93] transition-colors"
            >
              Enable Buyside Agents Search Your Property
            </button>
          </div>
        </div>
      </section>

      {/* 4. 4 FEATURE COLUMNS ON WHITE */}
      <section className="bg-white py-12 px-6">
        <div className="max-w-[1200px] mx-auto grid grid-cols-1 md:grid-cols-4 gap-8">
          {[
            {
              title: "VR Presentation",
              text: "A portal focused primarily on providing solutions enabling Virtual Reality presentations to increase the views to your listed properties effectively screening to reach your serious customers.",
            },
            {
              title: "No initial physical visit",
              text: "Show property options to clients without doing a physical visit saving significant time and money both for your Clients and You.",
            },
            {
              title: "Enhance Customer Experience",
              text: "Offer your customers an engaging and compelling limitless way to view properties multiple times from across geographies.",
            },
            {
              title: "Sell around the globe",
              text: "Increased access to global marketplaces: Buy side agents in other regions in your country and around the globe in Americas, Asia and many more countries.",
            },
          ].map((f) => (
            <div key={f.title}>
              <h3 style={{ fontFamily: "'DM Sans', sans-serif" }} className="font-bold text-[#262626] text-base mb-3">{f.title}</h3>
              <p className="text-[#2b2c2d] text-sm leading-relaxed">{f.text}</p>
            </div>
          ))}
        </div>
      </section>

      {/* 5. ALTERNATING ROWS - WHITE BG */}
      <section className="bg-white py-16 px-6">
        <div className="max-w-[1200px] mx-auto flex flex-col gap-16">
          {/* Row 1 - image left */}
          <div className="flex flex-col md:flex-row gap-10 items-center">
            <div className="md:w-1/2">
              <img
                src={`${ASSET_BASE}/demo-1.gif`}
                alt="3D capture"
                className="w-full rounded-[8px]"
              />
            </div>
            <div className="md:w-1/2">
              <p className="text-xs uppercase tracking-widest text-[#797068] mb-2">Via Frugone, Busalla, GE, Città Metropolitana di Genova, Italia, 16012</p>
              <h2 style={{ fontFamily: "'DM Sans', sans-serif" }} className="text-3xl font-bold text-[#2b2c2d] mb-4">It all starts with 3D capture.</h2>
              <p className="text-[#2b2c2d] text-sm leading-relaxed">A beautiful 90 sqm 2 bedroom apartment with lot of sunlight and views from most of the rooms with 2 balconies in Ligurian region of Italy.</p>
            </div>
          </div>
          {/* Row 2 - image right */}
          <div className="flex flex-col md:flex-row-reverse gap-10 items-center">
            <div className="md:w-1/2">
              <img
                src={`${ASSET_BASE}/demo-2.gif`}
                alt="AI insights"
                className="w-full rounded-[8px]"
              />
            </div>
            <div className="md:w-1/2">
              <p className="text-xs uppercase tracking-widest text-[#797068] mb-2">at OpenSky</p>
              <h2 style={{ fontFamily: "'DM Sans', sans-serif" }} className="text-3xl font-bold text-[#2b2c2d] mb-4">Unlock valuable insights powered by AI</h2>
              <p className="text-[#2b2c2d] text-sm leading-relaxed">Pair text with an image to focus on your chosen product, collection, or blog post. Add details on availability, style, or even provide a review.</p>
            </div>
          </div>
        </div>
      </section>

      {/* 6. GROW WITH OPENSKY - DARK BG WITH MAIN IMAGE */}
      <section
        className="relative py-32 px-6 flex items-center justify-center text-center"
        style={{
          backgroundImage: `url(${ASSET_BASE}/section-bg-1.jpg)`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="absolute inset-0 bg-[#1c2228]/70" />
        <div className="relative z-10">
          <h2 style={{ fontFamily: "'DM Sans', sans-serif" }} className="text-5xl md:text-6xl font-bold text-white mb-2">Grow With</h2>
          <p style={{ fontFamily: "'DM Sans', sans-serif" }} className="text-5xl md:text-6xl font-bold text-white mb-8">OPENSKY</p>
          <button
            onClick={goToLogin}
            className="px-8 py-3 rounded-[6px] bg-white text-[#001128] text-sm font-semibold hover:bg-white/90 transition-colors"
          >
            Learn More
          </button>
        </div>
      </section>

      {/* 7. EXAMPLES OF POSSIBILITIES + 360 IFRAME */}
      <section className="bg-white py-16 px-6">
        <div className="max-w-[1200px] mx-auto text-center mb-10">
          <h2 style={{ fontFamily: "'DM Sans', sans-serif" }} className="text-3xl md:text-4xl font-bold text-[#2b2c2d] mb-4">Examples of Possibilities</h2>
          <p className="text-[#2b2c2d] text-sm max-w-2xl mx-auto">
            Here is a 360 View of an upcoming project Layout Site view from a Birds Flyview, this can significantly enhance the presentation of your site to your investors.
          </p>
        </div>
        <div className="max-w-[1200px] mx-auto">
          <iframe
            src="https://vtour.cloud/nxrn5x/hyacn880/"
            width="100%"
            height="500px"
            frameBorder="0"
            title="360 tour"
            className="rounded-[8px]"
          />
        </div>
      </section>

      {/* 8. DIGITAL TWIN TEXT */}
      <section className="bg-white py-8 px-6 text-center">
        <div className="max-w-[1200px] mx-auto">
          <h2 style={{ fontFamily: "'DM Sans', sans-serif" }} className="text-2xl md:text-3xl font-bold text-[#2b2c2d] mb-3">
            Example: Digital Twin of Scanned Apartment for Sale
          </h2>
          <p className="text-[#2b2c2d] text-sm">This is the new revolutionary way to boost real estate sales and for client expansion.</p>
        </div>
      </section>

      {/* 9. CTA - CITY SLIDESHOW */}
      <section
        className="relative py-32 px-6 flex items-center justify-center text-center"
        style={{
          backgroundImage: `url(${ASSET_BASE}/section-bg-2.jpg)`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="absolute inset-0 bg-black/40" />
        <div className="relative z-10">
          <p className="text-white/80 text-xs uppercase tracking-widest mb-3">Real Estate At Its Best</p>
          <h2 style={{ fontFamily: "'DM Sans', sans-serif" }} className="text-4xl md:text-5xl font-bold text-white mb-8">
            Explode your property and agency sales.
          </h2>
          <button
            onClick={goToLogin}
            className="px-8 py-3 rounded-[6px] bg-[#b7aca2] text-[#262626] text-sm font-semibold hover:bg-[#a89d93] transition-colors"
          >
            Get Started
          </button>
        </div>
      </section>

      {/* 10. TESTIMONIALS - WHITE BG */}
      <section className="bg-white py-20 px-6">
        <div className="max-w-[1200px] mx-auto">
          <h2 style={{ fontFamily: "'DM Sans', sans-serif" }} className="text-3xl md:text-4xl font-bold text-[#2b2c2d] text-center mb-14">
            What Our Client's say about us?
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            {[
              { text: "Opensky is the future of real estate pitching. Profitable and easy!", author: "Rossana Lozzio" },
              { text: "Opensky made virtual real estate simple and profitable!", author: "Lorena" },
              { text: "Cool visualizations and property tours with Opensky!", author: "Daniel" },
              { text: "Impressive returns with OpenSky, Must Have!", author: "Kanumuri Prasad" },
            ].map((t) => (
              <div key={t.author} className="text-center">
                <p className="text-[#2b2c2d] font-semibold text-base mb-2">"{t.text}"</p>
                <p className="text-[#797068] text-sm">— {t.author}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="bg-[#1c2228] py-10 px-6">
        <div className="max-w-[1200px] mx-auto flex flex-col md:flex-row items-center justify-between gap-6">
          <img src="/images/logo.svg" alt="OpenSky" className="h-10 w-auto" />
          <div className="flex gap-6 text-sm text-white/60">
            <a href="/privacy_policy" className="hover:text-white transition-colors">Privacy Policy</a>
            <a href="/terms_and_conditions" className="hover:text-white transition-colors">Terms & Conditions</a>
          </div>
          <p className="text-white/60 text-xs">© {new Date().getFullYear()}, OpenSky VR RE Platform</p>
        </div>
      </footer>

    </div>
  );
};

export default LandingPage;
